import { render, staticRenderFns } from "./Inscription-final.vue?vue&type=template&id=f98cedac&scoped=true&"
import script from "./Inscription-final.vue?vue&type=script&lang=js&"
export * from "./Inscription-final.vue?vue&type=script&lang=js&"
import style0 from "./Inscription-final.vue?vue&type=style&index=0&id=f98cedac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98cedac",
  null
  
)

export default component.exports